import React from "react";
import { Box, Icon, Tooltip, Typography } from "@material-ui/core";

export const QuizInlineCardHeader = ({ title, tooltip }) => (
  <Box display="flex" alignItems="center" gap={8}>
    <Icon fontSize="small" style={{ marginRight: 6 }}>
      quiz
    </Icon>
    <Typography variant="body2" style={{ fontWeight: 600 }}>
      {title}
    </Typography>
    {tooltip && (
      <Tooltip title={tooltip}>
        <Icon fontSize="small" style={{ marginLeft: 2, cursor: "help" }}>
          info
        </Icon>
      </Tooltip>
    )}
  </Box>
);
